/*@flow*/
import NonEmptyArray from 'lib/NonEmptyArray';
import isArray from 'lib/t/isArray';

type ErrT = { graphQLErrors?: { message: string }[], message: string };

export default (err: ErrT): string[] => {
  if (isArray(err.graphQLErrors) && NonEmptyArray.is(err.graphQLErrors)) {
    return err.graphQLErrors.map(v => v.message);
  }
  return [err.message];
};
